export default __webpack_public_path__ + "static/media/IMG_5339.37d4d092.WEBP";